export interface RatingPeriodToRate {
    missionIds: number[];
    extra: Extra;
    jobName: string;
    periodMissionsCount: number;
    periodEndDatetime: string;
    periodStartDatetime: string;
}

export interface RatingPeriodRated {
    id: number;
    extra: Extra;
    jobName: string;
    periodMissionsCount: number;
    periodEndDatetime: string;
    periodStartDatetime: string;
    rating: number;
    comment: string;
}

export interface Extra {
    extraId: number;
    fullName: string;
    pictureUrl: string;
}

export interface IRatingPeriodsRateToApi {
    rate: number;
    comment?: string;
    missionPeriods: MissionPeriods[];
}

export interface MissionPeriods {
    missionIds: number[];
}

export const MINIMAL_RATING_DEFAULT_COMMENT = 2;
